var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7422_6999)",
    filter: "url(#filter0_d_7422_6999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5614 8.3495C14.4816 9.24651 14.2638 10.111 13.9081 10.9392H10.9473C11.6697 9.84515 12.0078 8.69993 11.9801 7.42733C11.9717 7.02311 12.2644 6.67491 12.6633 6.60964C12.6721 6.60833 12.6805 6.60702 12.6893 6.60565C13.7331 6.43508 14.6544 7.29553 14.5614 8.3495Z",
    fill: "url(#paint0_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7673 10.7289L9.28516 10.7285V18.0801H12.6696H17.1095H17.4785C18.4392 18.0801 19.2592 17.3856 19.4173 16.438L19.9837 12.1651C20.1091 11.4133 19.5294 10.7289 18.7673 10.7289Z",
    fill: "url(#paint1_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1095 18.0802H17.4786C18.155 18.0802 18.7612 17.7357 19.1162 17.2012L11.0553 10.7286L9.28516 10.7285V18.0801H12.6697L17.1095 18.0802Z",
    fill: "url(#paint2_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6915 18.5299H9.8134C9.60149 18.5299 9.42969 18.3581 9.42969 18.1462V10.663C9.42969 10.4511 9.60149 10.2793 9.8134 10.2793H10.6915C10.9034 10.2793 11.0752 10.4511 11.0752 10.663V18.1462C11.0752 18.3582 10.9034 18.5299 10.6915 18.5299Z",
    fill: "url(#paint3_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1046 10.2793H9.8134C9.60149 10.2793 9.42969 10.4511 9.42969 10.663V18.1463C9.42969 18.3582 9.60149 18.53 9.8134 18.53H10.6915C10.9034 18.53 11.0752 18.3582 11.0752 18.1463V11.2498L10.1046 10.2793Z",
    fill: "url(#paint4_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70202 19.0514H6.40015C6.17916 19.0514 6 18.8723 6 18.6513V10.158C6 9.93697 6.17916 9.75781 6.40015 9.75781H9.70202C9.92304 9.75781 10.1022 9.93697 10.1022 10.158V18.6513C10.1022 18.8723 9.92301 19.0514 9.70202 19.0514Z",
    fill: "url(#paint5_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1014 12.2204L8.7938 10.9128C8.60932 10.7119 8.34457 10.5859 8.05033 10.5859C7.4929 10.5859 7.04102 11.0378 7.04102 11.5953C7.04102 11.8895 7.16702 12.1543 7.36791 12.3387L10.1014 15.0722V12.2204H10.1014Z",
    fill: "url(#paint6_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05033 12.6046C8.60776 12.6046 9.05964 12.1527 9.05964 11.5952C9.05964 11.0378 8.60776 10.5859 8.05033 10.5859C7.4929 10.5859 7.04102 11.0378 7.04102 11.5952C7.04102 12.1527 7.4929 12.6046 8.05033 12.6046Z",
    fill: "url(#paint7_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05202 12.2915C8.43672 12.2915 8.74858 11.9797 8.74858 11.595C8.74858 11.2103 8.43672 10.8984 8.05202 10.8984C7.66733 10.8984 7.35547 11.2103 7.35547 11.595C7.35547 11.9797 7.66733 12.2915 8.05202 12.2915Z",
    fill: "url(#paint8_linear_7422_6999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78671 11.4758C7.86631 11.4758 7.93084 11.4112 7.93084 11.3316C7.93084 11.252 7.86631 11.1875 7.78671 11.1875C7.70711 11.1875 7.64258 11.252 7.64258 11.3316C7.64258 11.4112 7.70711 11.4758 7.78671 11.4758Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.316 11.4758C8.3956 11.4758 8.46013 11.4112 8.46013 11.3316C8.46013 11.252 8.3956 11.1875 8.316 11.1875C8.2364 11.1875 8.17188 11.252 8.17188 11.3316C8.17188 11.4112 8.2364 11.4758 8.316 11.4758Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78671 12.0051C7.86631 12.0051 7.93084 11.9405 7.93084 11.8609C7.93084 11.7813 7.86631 11.7168 7.78671 11.7168C7.70711 11.7168 7.64258 11.7813 7.64258 11.8609C7.64258 11.9405 7.70711 12.0051 7.78671 12.0051Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.316 12.0051C8.3956 12.0051 8.46013 11.9405 8.46013 11.8609C8.46013 11.7813 8.3956 11.7168 8.316 11.7168C8.2364 11.7168 8.17188 11.7813 8.17188 11.8609C8.17188 11.9405 8.2364 12.0051 8.316 12.0051Z",
    fill: "#FFB92D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7422_6999",
    x: 4,
    y: 6,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.403922 0 0 0 0 0.403922 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7422_6999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7422_6999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7422_6999",
    x1: 11.3667,
    y1: 9.31637,
    x2: 12.8382,
    y2: 11.6403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7422_6999",
    x1: 10.7302,
    y1: 16.2517,
    x2: 15.801,
    y2: 21.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7422_6999",
    x1: 17.286,
    y1: 11.7471,
    x2: 10.1788,
    y2: 11.7471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7422_6999",
    x1: 8.88358,
    y1: 19.5447,
    x2: 12.5061,
    y2: 19.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7422_6999",
    x1: 10.303,
    y1: 7.32075,
    x2: 7.40354,
    y2: 7.26494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C3C3",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7422_6999",
    x1: 5.7036,
    y1: 17.102,
    x2: 11.956,
    y2: 20.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7422_6999",
    x1: 10.3621,
    y1: 10.8694,
    x2: 6.95518,
    y2: 9.28393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2F3",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7422_6999",
    x1: 7.32052,
    y1: 10.9619,
    x2: 7.32052,
    y2: 12.4214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7422_6999",
    x1: 8.55556,
    y1: 12.0324,
    x2: 8.55556,
    y2: 11.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7422_6999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4958eedc1f003d8ee0e0c90cfcab8e4d.svg";
export { ForwardRef as ReactComponent };